/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Transition_Rotation_LabelInputs */

const bn_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ঘূর্ণন`)
};

const de_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DREHUNG`)
};

const el_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΠΕΡΙΣΤΡΟΦΗ`)
};

const en_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROTATION`)
};

const es_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROTACIÓN`)
};

const fr_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROTATION`)
};

const hi_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROTATION`)
};

const hu_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FORGÁS`)
};

const id_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROTASI`)
};

const it_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROTAZIONE`)
};

const ja_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回転`)
};

const ko_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회전`)
};

const nl_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROTATIE`)
};

const pl_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OBRÓT`)
};

const pt_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROTAÇÃO`)
};

const ru_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ВРАЩЕНИЕ`)
};

const sv_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROTATION`)
};

const tr_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DÖNME`)
};

const uk_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`РОТАЦІЯ`)
};

const vi_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QUAY`)
};

const zh_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旋转`)
};

const zh_hant_cipher_transition_rotation_label = /** @type {(inputs: Cipher_Transition_Rotation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旋轉`)
};

/**
* | output |
* | --- |
* | "ROTATION" |
*
* @param {Cipher_Transition_Rotation_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_transition_rotation_label = /** @type {((inputs?: Cipher_Transition_Rotation_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Transition_Rotation_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_transition_rotation_label(inputs)
	if (locale === "de") return de_cipher_transition_rotation_label(inputs)
	if (locale === "el") return el_cipher_transition_rotation_label(inputs)
	if (locale === "en") return en_cipher_transition_rotation_label(inputs)
	if (locale === "es") return es_cipher_transition_rotation_label(inputs)
	if (locale === "fr") return fr_cipher_transition_rotation_label(inputs)
	if (locale === "hi") return hi_cipher_transition_rotation_label(inputs)
	if (locale === "hu") return hu_cipher_transition_rotation_label(inputs)
	if (locale === "id") return id_cipher_transition_rotation_label(inputs)
	if (locale === "it") return it_cipher_transition_rotation_label(inputs)
	if (locale === "ja") return ja_cipher_transition_rotation_label(inputs)
	if (locale === "ko") return ko_cipher_transition_rotation_label(inputs)
	if (locale === "nl") return nl_cipher_transition_rotation_label(inputs)
	if (locale === "pl") return pl_cipher_transition_rotation_label(inputs)
	if (locale === "pt") return pt_cipher_transition_rotation_label(inputs)
	if (locale === "ru") return ru_cipher_transition_rotation_label(inputs)
	if (locale === "sv") return sv_cipher_transition_rotation_label(inputs)
	if (locale === "tr") return tr_cipher_transition_rotation_label(inputs)
	if (locale === "uk") return uk_cipher_transition_rotation_label(inputs)
	if (locale === "vi") return vi_cipher_transition_rotation_label(inputs)
	if (locale === "zh") return zh_cipher_transition_rotation_label(inputs)
	return zh_hant_cipher_transition_rotation_label(inputs)
});